'use client';

import Link from 'next/link';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { DISCORD_URL } from '@shared/config/constants';
import DialogIcon from '@public/icons/dialog.svg';

import styles from './CommunityChat.module.scss';

const CommunityChat = () => {
  const t = useTranslations();

  return (
    <Link href={DISCORD_URL} className={styles.container} target="_blank">
      <Image src={DialogIcon} className={styles.icon} alt="Dialog" draggable={false} />
      <div>{t('communityChat')}</div>
      <div className={styles.indicator} />
    </Link>
  );
};

export default CommunityChat;
